import { type ObjectValuesUnionType } from '../../../utils/typing';

import { KLRounds } from './round';

export const KLViewTypes = Object.freeze({
  ...KLRounds,
  BADGE_DETAIL: 'BADGE_DETAIL',
  COUNCIL: 'COUNCIL',
  ELIMINATED: 'ELIMINATED',
  ENROLLMENT: 'ENROLLMENT',
});

export type KLViewType = ObjectValuesUnionType<typeof KLViewTypes>;
